import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice';
import entityReducer from "./entitySlice";
import refreshReducer from "./refresh";
import templateTreeReducer from './templateTreeSlice';
import customEntityReducer from './customEntitySlice';

import MFEntityReducer from './MFEntityTree'
import FGEntityReducer from './FGEntityTree'
import BPEntityReducer from './BPEntityTree'
import PREntityReducer from './PREntityTree'
import CIEntityReducer from './CIEntityTree'


import MFCustomManageScreenRedux from './MFCustomManageScreenRedux';
import FGCustomManageScreenRedux from './FGCustomManageScreenRedux';
import BPCustomManageScreenRedux from './BPCustomManageScreenRedux';
import CICustomManageScreenRedux from './CICustomManageScreenRedux';
import PRCustomManageScreenRedux from './PRCustomManageScreenRedux';

import MFTemplateTreeReducer from './MFTemplateTreeSlice'
import FGTemplateTreeReducer from './FGTemplateTreeSlice'
import BPTemplateTreeReducer from './BPTemplateTreeSlice'
import CITemplateTreeReducer from './CITemplateTreeSlice'
import PRTemplateTreeReducer from './PRTemplateTreeSlice'

import FGManageScreenRedux from './FGManageScreenRedux';
import BPManageScreenRedux from './BPManageScreenRedux';
import PRManageScreenRedux from './PRManageScreenRedux';
import CIManageScreenRedux from './CIManageScreenRedux';
import MFManageScreenRedux from './MFManageScreenRedux';
import realignmentReducer from './realignmentSlice';
import profitCenterConfigurationReducer from './profitCenterConfigurationSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    entity: entityReducer,
    refresh: refreshReducer,
    templateTree: templateTreeReducer,
    MFTemplateTree: MFTemplateTreeReducer,
    FGTemplateTree: FGTemplateTreeReducer,
    BPTemplateTree: BPTemplateTreeReducer,
    CITemplateTree: CITemplateTreeReducer,
    PRTemplateTree: PRTemplateTreeReducer,
    customEntity: customEntityReducer,
    MFentity: MFEntityReducer,
    FGentity: FGEntityReducer,
    BPentity: BPEntityReducer,
    PRentity: PREntityReducer,
    CIentity: CIEntityReducer,
    MFManageScreenRedux: MFManageScreenRedux,
    MFCustomManageScreenRedux: MFCustomManageScreenRedux,
    FGCustomManageScreenRedux: FGCustomManageScreenRedux,
    BPCustomManageScreenRedux: BPCustomManageScreenRedux,
    CICustomManageScreenRedux: CICustomManageScreenRedux,
    PRCustomManageScreenRedux: PRCustomManageScreenRedux,
    PRManageScreenRedux: PRManageScreenRedux,
    CIManageScreenRedux: CIManageScreenRedux,
    BPManageScreenRedux: BPManageScreenRedux,
    FGManageScreenRedux: FGManageScreenRedux,
    realignment: realignmentReducer,
    profitCenterConfiguration: profitCenterConfigurationReducer,
  },
})

export default store;